import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import Dropdown from 'react-dropdown';
import tinycolor from 'tinycolor2';
import 'react-dropdown/style.css';

import { joinClassNames } from '../../util/util';
import { setCartArray, setCurrentPrebasketProduct, setPrebasketUpdated } from '../../actions/shoppingActions';
import { setShowShoppingCart } from '../../actions/playerActions';

import './ShoppingBasket.scss';

class ShoppingBasket extends PureComponent {
	constructor() {
		super();
		this.state = {
			currentTab: 'cart',
			currentCart: [],
			prebasketProduct: {},
			variationValue1: 'blue',
			variationValue2: '36',
			currentSilderIndex: 0,
			currentComboIndex: 0,
			currentDropdownValue1: '',
			currentDropdownValue2: '',
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.showShoppingCart !== prevProps.showShoppingCart) {
			if (this.props.showShoppingCart === false) {
				this.setState({ currentTab: 'cart' });
			}
		}

		if (this.props.prebasketUpdated !== prevProps.prebasketUpdated) {
			if (this.props.prebasketUpdated === true && Object.keys(this.props.currentPrebasketProduct).length > 0) {
				this.setState(
					{
						currentTab: 'prebasket',
						prebasketProduct: this.props.currentPrebasketProduct,
						currentComboIndex: 0,
						currentDropdownValue1: this.props.currentPrebasketProduct.variantValues1.value[0],
						currentDropdownValue2: this.props.currentPrebasketProduct.variantValues2.value[0],
					},
					() => {
						this.props.setPrebasketUpdated(false);
					}
				);
			}
		}

		if (this.props.cartQuantity !== prevProps.cartQuantity) {
			this.setState({ currentCart: this.props.cartArray }); // used to rerender the component propperly
		}

		if (
			this.state.currentDropdownValue1 !== prevState.currentDropdownValue1 ||
			this.state.currentDropdownValue2 !== prevState.currentDropdownValue2
		) {
			if (Object.keys(this.props.currentPrebasketProduct).length > 0) {
				let tempName = '';
				if (this.props.currentPrebasketProduct.variantName1.value !== '' && this.props.currentPrebasketProduct.variantName2.value !== '') {
					tempName = this.state.currentDropdownValue1 + '-' + this.state.currentDropdownValue2;
				} else if (
					this.props.currentPrebasketProduct.variantName1.value !== '' &&
					this.props.currentPrebasketProduct.variantName2.value === ''
				) {
					tempName = this.state.currentDropdownValue1;
				}
				if (this.props.currentPrebasketProduct.variantName1.value === '' && this.props.currentPrebasketProduct.variantName2.value !== '') {
					tempName = this.state.currentDropdownValue2;
				}

				let tempIndex = this.props.currentPrebasketProduct.variantCombinations.value.findIndex((item) => item.comboName === tempName);

				this.setState({ currentComboIndex: tempIndex });
			}
		}

		if (this.state.currentComboIndex !== prevState.currentComboIndex) {
			this.setState({ currentSilderIndex: this.state.currentComboIndex });
		}
	}

	handleCartButtonClick = () => {
		this.setState({ currentTab: 'cart' });
	};

	handleShoppingListButtonClick = () => {
		this.setState({ currentTab: 'list' });
	};

	handleIncreaseQuantity = (id) => {
		let tempArray = this.props.cartArray;

		let productIndex = tempArray.findIndex((item) => item.productId === id);
		tempArray[productIndex].quantity = +tempArray[productIndex].quantity + 1;

		this.props.setCartArray(tempArray);
	};

	handleDecreaseQuantity = (id) => {
		let tempArray = this.props.cartArray;

		let productIndex = tempArray.findIndex((item) => item.productId === id);

		if (tempArray[productIndex].quantity > 1) {
			tempArray[productIndex].quantity = +tempArray[productIndex].quantity - 1;

			this.props.setCartArray(tempArray);
		}
	};

	handleUpdateInputField = (event, id) => {
		let tempArray = this.props.cartArray;

		let productIndex = tempArray.findIndex((item) => item.productId === id);
		tempArray[productIndex].quantity = +event.target.value;

		this.props.setCartArray(tempArray);
	};

	handleDeleteItemFromCart = (id) => {
		let tempArray = this.props.cartArray;

		let productIndex = tempArray.findIndex((item) => item.productId === id);

		if (productIndex > -1) {
			tempArray.splice(productIndex, 1); // 2nd parameter means remove one item only
		}

		this.props.setCartArray(tempArray);
	};

	handleButtonCloseCart = (value) => {
		this.props.setShowShoppingCart(!value);
	};

	handleViewProductButton = (product) => {
		this.props.setCurrentPrebasketProduct(product);
		this.props.setPrebasketUpdated(true);
	};

	handlePrebasketAddToCart = (product, variantValue1, variantValue2) => {
		let obj = {};

		if (product.variantName1?.value === '') {
			obj = {
				productId: product.prodId?.value,
				productPage: product.prodPage?.value,
				name: product.prodName?.value,
				price: product.price?.value,
				quantity:
					product.hideVolumeCounter === undefined || (product.hideVolumeCounter !== undefined && product.hideVolumeCounter?.value === false)
						? '1'
						: '0',
				description:
					product.prodDescription?.value + (product.hideVolumeCounter === undefined ? '' : '(=' + product.hideVolumeCounter?.value),
				image: product.imageUrl?.value,
			};
		} else if (product.variantName2.value === '') {
			obj = {
				productId: product.prodId?.value,
				productPage: product.prodPage?.value,
				name: product.prodName?.value,
				price: product.price?.value,
				quantity:
					product.hideVolumeCounter === undefined || (product.hideVolumeCounter !== undefined && product.hideVolumeCounter?.value === false)
						? '1'
						: '0',
				description:
					product.prodDescription?.value + (product.hideVolumeCounter === undefined ? '' : '(=' + product.hideVolumeCounter?.value),
				image: product.imageUrl?.value,
				variantText1: product.variantName1?.value,
				variantValue1: variantValue1,
			};
		} else {
			obj = {
				productId: product.variantCombinations?.value[this.state.currentComboIndex]?.comboId,
				productPage: product.prodPage?.value,
				name: product.prodName?.value,
				price: product.variantCombinations?.value[this.state.currentComboIndex]?.comboPrice + ' ' + product.price.value.split(' ')[1],
				quantity:
					product.hideVolumeCounter === undefined || (product.hideVolumeCounter !== undefined && product.hideVolumeCounter?.value === false)
						? '1'
						: '0',
				description:
					product.prodDescription?.value + (product.hideVolumeCounter === undefined ? '' : '(=' + product.hideVolumeCounter?.value),
				image: product.variantCombinations?.value[this.state.currentComboIndex].comboImg,
				variantText1: product.variantName1?.value,
				variantValue1: variantValue1,
				variantText2: product.variantName2?.value,
				variantValue2: variantValue2,
			};
		}

		if (!this.props.cartArray.some((el) => el.productId === obj.productId)) {
			let tempArray = this.props.cartArray;
			tempArray.push(obj);

			this.props.setCartArray(tempArray);
		}

		this.setState({ currentTab: 'cart', prebasketProduct: {}, currentDropValue1: '', currentDropValue2: '' }, () => {
			this.props.setCurrentPrebasketProduct({});
		});
	};

	whichIsTheGreatest = (numericValues) => {
		if (Math.max(numericValues.EUR, numericValues.SEK, numericValues.DKK, numericValues.NOK, numericValues.USD, numericValues.GBP) === 0) {
			return ' ';
		} else {
			var max = -Infinity; // calling Math.max with no arguments returns -Infinity
			var maxName = null;
			for (var key in numericValues) {
				var num = numericValues[key];

				if (num > max) {
					max = num;
					maxName = key;
				}

				max = (num > max && num) || max;
			}

			return maxName;
		}
	};

	getTotalPrice = (cartArray) => {
		let resultPrice = 0;

		let countEur = 0;
		let countSek = 0;
		let countDkk = 0;
		let countNok = 0;
		let countUsd = 0;
		let countGbp = 0;

		if (cartArray.length > 0) {
			for (var i = 0; i <= cartArray.length; i++) {
				if (cartArray[i]) {
					resultPrice =
						resultPrice +
						Number(cartArray[i].price.split(' ')[0]) * (Number(cartArray[i].quantity) === 0 ? 1 : Number(cartArray[i].quantity));

					switch (cartArray[i].price.split(' ')[1]) {
						case 'EUR':
							countEur = countEur + 1;
							break;
						case 'SEK':
							countSek = countSek + 1;
							break;
						case 'DKK':
							countDkk = countDkk + 1;
							break;
						case 'NOK':
							countNok = countNok + 1;
							break;
						case 'USD':
							countUsd = countUsd + 1;
							break;
						case 'GBP':
							countGbp = countGbp + 1;
							break;
						default:
							console.warn('unknown currency');
					}
				}
			}
		}

		let curencyValues = {
			EUR: countEur,
			SEK: countSek,
			DKK: countDkk,
			NOK: countNok,
			USD: countUsd,
			GBP: countGbp,
		};

		return <div className="shoppingBasketCartTotalPriceValue">{resultPrice + ' ' + this.whichIsTheGreatest(curencyValues)}</div>;
	};

	renderCartProduct = (product) => {
		const primaryBGColor = { backgroundColor: this.props.settings?.playerStyling?.primaryColor ?? '#126cfc' };

		let variant1 = '';
		let variant2 = '';

		if (product.variantText1 !== undefined && product.variantValue1 !== undefined) {
			variant1 = product.variantText1 + ': ' + product.variantValue1;
		}

		if (product.variantText2 !== undefined && product.variantValue2 !== undefined) {
			variant2 = product.variantText2 + ': ' + product.variantValue2;
		}

		return (
			<div className="shoppingBasketCartSingleProduct">
				<div className="shoppingBasketCartSingleProductImageWrapper">
					<img className="shoppingBasketCartSingleProductImage" src={product.image}></img>
				</div>
				<div className="shoppingBasketCartSingleProductMiddleSection">
					<a href={product.productPage} target="_blank" className="shoppingBasketCartSingleProductMiddleSectionTitle" rel="noreferrer">
						{product.name}
					</a>
					<div className="shoppingBasketCartSingleProductMiddleSectionPrice">{product.price}</div>
					<div className="shoppingBasketCartSingleProductMiddleSectionVariantWrapper">
						<div className="shoppingBasketCartSingleProductMiddleSectionVariantText">{variant1}</div>
						<div className="shoppingBasketCartSingleProductMiddleSectionVariantText">{variant2}</div>
					</div>
					<div className="shoppingBasketCartSingleProductMiddleSectionQuantityWrapper">
						<div
							className="shoppingBasketCartSingleProductMiddleSectionQuantityBtn"
							onClick={() => this.handleDecreaseQuantity(product.productId)}
							style={primaryBGColor}
						>
							-
						</div>
						<input
							className="shoppingBasketCartSingleProductMiddleSectionQuantityInput"
							type="number"
							onChange={(event) => this.handleUpdateInputField(event, product.productId)}
							value={product.quantity}
						></input>
						<div
							className="shoppingBasketCartSingleProductMiddleSectionQuantityBtn"
							onClick={() => this.handleIncreaseQuantity(product.productId)}
							style={primaryBGColor}
						>
							+
						</div>

						<div className="shoppingBasketCartSingleProductDeleteSection">
							<div
								className="shoppingBasketCartSingleProductDeleteSectionButton"
								onClick={() => this.handleDeleteItemFromCart(product.productId)}
							>
								<svg xmlns="http://www.w3.org/2000/svg" width="11.375" height="13.125" viewBox="0 0 11.375 13.125">
									<path
										id="trash-fill"
										d="M2.375.875A.875.875,0,0,0,1.5,1.75v.875a.875.875,0,0,0,.875.875h.438v7.875a1.75,1.75,0,0,0,1.75,1.75h5.25a1.75,1.75,0,0,0,1.75-1.75V3.5H12a.875.875,0,0,0,.875-.875V1.75A.875.875,0,0,0,12,.875H8.937A.875.875,0,0,0,8.062,0H6.312a.875.875,0,0,0-.875.875ZM5,4.375a.437.437,0,0,1,.438.437v6.125a.437.437,0,0,1-.875,0V4.812A.437.437,0,0,1,5,4.375Zm2.187,0a.438.438,0,0,1,.438.437v6.125a.438.438,0,0,1-.875,0V4.812A.437.437,0,0,1,7.187,4.375Zm2.625.437a.438.438,0,0,0-.875,0v6.125a.438.438,0,0,0,.875,0Z"
										transform="translate(-1.5)"
										fillRule="evenodd"
									/>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderListProduct = (product) => {
		const color = this.props.settings?.playerStyling?.primaryColor ?? '#126cfc';
		const primaryColor = { color: color };
		const primaryBGColor = { backgroundColor: tinycolor({ ...tinycolor(color).toRgb(), a: 0.2 }).toRgbString() };

		return (
			<div className="shoppingBasketListSingleProduct">
				<div className="shoppingBasketListSingleProductImageWrapper">
					<img className="shoppingBasketCartSingleProductImage" src={product.imageUrl.value}></img>
				</div>
				<div className="shoppingBasketListSingleProductMiddleSection">
					<div className="shoppingBasketCartSingleProductMiddleSectionInfo">
						<a
							href={product.prodPage.value}
							target="_blank"
							className="shoppingBasketCartSingleProductMiddleSectionTitle"
							rel="noreferrer"
						>
							{product.prodName?.value}
						</a>
						<div
							href={product.prodPage.value}
							target="_blank"
							className="shoppingBasketCartSingleProductMiddleSectionDes"
							rel="noreferrer"
						>
							{product.prodDescription?.value}
						</div>
						<div className="shoppingBasketCartSingleProductMiddleSectionPrice">{product.price.value}</div>
					</div>
					<div
						className="shoppingBasketListSingleProductMiddleSectionViewButton"
						style={{ ...primaryColor, ...primaryBGColor }}
						onClick={() => this.handleViewProductButton(product)}
					>
						{this.props.t('VIEW_PRODUCT')}
					</div>
				</div>
			</div>
		);
	};
	onClickNav = () => {
		this.setState({ currentSilderIndex: 0 });
	};

	handleClickNextSlider = (currentSilderIndex, max) => {
		if (currentSilderIndex < max - 1) {
			this.setState({ currentSilderIndex: currentSilderIndex + 1 });
		} else {
			this.setState({ currentSilderIndex: 0 });
		}
	};

	handleClickPrevSlider = (currentSilderIndex, max) => {
		if (currentSilderIndex > 0) {
			this.setState({ currentSilderIndex: currentSilderIndex - 1 });
		} else {
			this.setState({ currentSilderIndex: max - 1 });
		}
	};

	getCurrentSlideMargin = (slideIndex) => {
		return -Math.abs(slideIndex * 100) + '%';
	};

	handleDropdownVariants1 = (event) => {
		this.setState({ currentDropdownValue1: event.value });
	};

	handleDropdownVariants2 = (event) => {
		this.setState({ currentDropdownValue2: event.value });
	};

	handleCheckoutButton = (cartArray) => {
		window.parent.postMessage(
			{
				identifier: 'qbrick-shopping',
				shoppingItems: cartArray,
			},
			'*'
		);

		this.props.setShowShoppingCart(false);
	};

	getImageUrl = (product) => {
		return product.imageUrl.value;
	};

	renderPrebasket = (product) => {
		if (product.variantName1.value === '' && product.variantName2.value === '') {
			if (product.imageUrl.value) {
				return (
					<>
						<div className="shoppingBasketPreBasketWrapper">
							<div className="shoppingBasketPreBasketSlideshow">
								<div className="shoppingBasketPreBasketSlideshowImages">
									<div>
										<img src={product.imageUrl.value}></img>
									</div>
								</div>
							</div>
							<div className="shoppingBasketPreBasketTitlePriceWrapper">
								<div className="shoppingBasketPreBasketTitle">{product.prodName.value}</div>
								<div className="shoppingBasketPreBasketPrice">{product.price.value}</div>
							</div>
							<div className="shoppingBasketPreBasketDes">{product.prodDescription.value}</div>
						</div>
						<div
							className="shoppingBasketListSingleProductMiddleSectionViewButton"
							onClick={() => this.handlePrebasketAddToCart(product, this.state.variationValue1, this.state.variationValue1)}
						>
							{this.props.t('ADD_TO_CART')}
						</div>
					</>
				);
			}
		} else if (product.variantName2.value === '') {
			let images = product.variantCombinations.value.map((item) => {
				return { url: item.comboImg === '' ? this.state.prebasketProduct.imageUrl.value : item.comboImg };
			});

			/* let images = []

            for (var i = 0; i > product.variantCombinations.value.length; i++) {
                let tempItem = { url: product.variantCombinations.value[i].comboImg === '' ? product.imageUrl.value : product.variantCombinations.value[i].comboImg }
                images.push(tempItem)
            } */

			let priceValue = product.variantCombinations.value[this.state.currentComboIndex].comboPrice + ' ' + product.price.value.split(' ')[1];
			let currentDropValue1 = product.variantValues1.value[0];
			return (
				<>
					<div className="shoppingBasketPreBasketWrapper">
						<div className="shoppingBasketPreBasketSlideshow">
							<div className="shoppingBasketPreBasketSlideshowImages">
								{images.map((img, index) => {
									if (index === 0) {
										return (
											<div
												key={index}
												className="firstImage"
												style={{
													marginLeft: this.getCurrentSlideMargin(this.state.currentSilderIndex),
												}}
											>
												<img src={img.url}></img>
											</div>
										);
									} else {
										return (
											<div key={index}>
												<img key={index} src={img.url}></img>
											</div>
										);
									}
								})}
							</div>
							<a
								className="prebasketSlideshowPrev"
								onClick={() => this.handleClickPrevSlider(this.state.currentSilderIndex, images.length)}
							>
								❮
							</a>
							<a
								className="prebasketSlideshowNext"
								onClick={() => this.handleClickNextSlider(this.state.currentSilderIndex, images.length)}
							>
								❯
							</a>
						</div>
						<div className="shoppingBasketPreBasketTitlePriceWrapper">
							<div className="shoppingBasketPreBasketTitle">{product.prodName.value}</div>
							<div className="shoppingBasketPreBasketPrice">{priceValue}</div>
						</div>
						<div className="shoppingBasketPreBasketDes">{product.prodDescription.value}</div>

						<div className="shoppingBasketPreBasketDropdownWrapper">
							<div className="shoppingBasketPreBasketDropdownVariantSingle">
								<div className="shoppingBasketPreBasketDropdownVariantName">{product.variantName1.value}</div>
								<Dropdown
									className="shoppingBasketPreBasketDropdownVariantDropWrapper"
									menuClassName="shoppingBasketPreBasketDropdownMenu"
									placeholderClassName="shoppingBasketPreBasketDropdownPlaceholder"
									options={product.variantValues1.value}
									onChange={(e) => this.handleDropdownVariants1(e)}
									value={currentDropValue1}
									placeholder="Select an option"
								/>
							</div>
						</div>
					</div>
					<div
						className="shoppingBasketListSingleProductMiddleSectionViewButton"
						onClick={() => this.handlePrebasketAddToCart(product, this.state.currentDropdownValue1, this.state.currentDropdownValue2)}
					>
						{this.props.t('ADD_TO_CART')}
					</div>
				</>
			);
		} else if (product.variantName1.value === '') {
			let images = product.variantCombinations.value.map((item) => {
				return { url: item.comboImg === '' ? this.state.prebasketProduct.imageUrl.value : item.comboImg };
			});

			let priceValue = product.variantCombinations.value[this.state.currentComboIndex].comboPrice + ' ' + product.price.value.split(' ')[1];
			let currentDropValue2 = product.variantValues2.value[0];
			return (
				<>
					<div className="shoppingBasketPreBasketWrapper">
						<div className="shoppingBasketPreBasketSlideshow">
							<div className="shoppingBasketPreBasketSlideshowImages">
								{images.map((img, index) => {
									if (index === 0) {
										return (
											<div
												key={index}
												className="firstImage"
												style={{
													marginLeft: this.getCurrentSlideMargin(this.state.currentSilderIndex),
												}}
											>
												<img src={img.url}></img>
											</div>
										);
									} else {
										return (
											<div key={index}>
												<img src={img.url}></img>
											</div>
										);
									}
								})}
							</div>
							<a
								className="prebasketSlideshowPrev"
								onClick={() => this.handleClickPrevSlider(this.state.currentSilderIndex, images.length)}
							>
								❮
							</a>
							<a
								className="prebasketSlideshowNext"
								onClick={() => this.handleClickNextSlider(this.state.currentSilderIndex, images.length)}
							>
								❯
							</a>
						</div>
						<div className="shoppingBasketPreBasketTitlePriceWrapper">
							<div className="shoppingBasketPreBasketTitle">{product.prodName.value}</div>
							<div className="shoppingBasketPreBasketPrice">{priceValue}</div>
						</div>

						<div className="shoppingBasketPreBasketDes">{product.prodDescription.value}</div>

						<div className="shoppingBasketPreBasketDropdownWrapper">
							<div className="shoppingBasketPreBasketDropdownVariantSingle">
								<div className="shoppingBasketPreBasketDropdownVariantName">{product.variantName2.value}</div>
								<Dropdown
									className="shoppingBasketPreBasketDropdownVariantDropWrapper"
									menuClassName="shoppingBasketPreBasketDropdownMenu"
									placeholderClassName="shoppingBasketPreBasketDropdownPlaceholder"
									options={product.variantValues2.value}
									onChange={(e) => this.handleDropdownVariants2(e)}
									value={currentDropValue2}
									placeholder="Select an option"
								/>
							</div>
						</div>
					</div>

					<div
						className="shoppingBasketListSingleProductMiddleSectionViewButton"
						onClick={() => this.handlePrebasketAddToCart(product, this.state.currentDropdownValue1, this.state.currentDropdownValue2)}
					>
						{this.props.t('ADD_TO_CART')}
					</div>
				</>
			);
		} else if (product.variantName1.value !== '' && product.variantName2.value !== '') {
			/* let images = [{ url: product.imageUrl.value }, { url: product.variantCombinations.value[1].comboImg }, { url: product.variantCombinations.value[1].comboImg }] */
			let images = product.variantCombinations.value.map((item) => {
				return { url: item.comboImg };
			});

			let priceValue = product.variantCombinations?.value[this.state.currentComboIndex]?.comboPrice + ' ' + product.price.value.split(' ')[1];
			let currentDropValue1 = product.variantValues1.value[0];
			let currentDropValue2 = product.variantValues2.value[0];
			return (
				<>
					<div className="shoppingBasketPreBasketWrapper">
						<div className="shoppingBasketPreBasketSlideshow">
							<div className="shoppingBasketPreBasketSlideshowImages">
								{images.map((img, index) => {
									if (index === 0) {
										return (
											<div
												key={index}
												className="firstImage"
												style={{
													marginLeft: this.getCurrentSlideMargin(this.state.currentSilderIndex),
												}}
											>
												<img src={img.url}></img>
											</div>
										);
									} else {
										return (
											<div key={index}>
												<img src={img.url}></img>
											</div>
										);
									}
								})}
							</div>
							<a
								className="prebasketSlideshowPrev"
								onClick={() => this.handleClickPrevSlider(this.state.currentSilderIndex, images.length)}
							>
								❮
							</a>
							<a
								className="prebasketSlideshowNext"
								onClick={() => this.handleClickNextSlider(this.state.currentSilderIndex, images.length)}
							>
								❯
							</a>
						</div>
						<div className="shoppingBasketPreBasketTitlePriceWrapper">
							<div className="shoppingBasketPreBasketTitle">{product.prodName.value}</div>
							<div className="shoppingBasketPreBasketPrice">{priceValue}</div>
						</div>
						<div className="shoppingBasketPreBasketDes">{product.prodDescription.value}</div>

						<div className="shoppingBasketPreBasketDropdownWrapper">
							<div className="shoppingBasketPreBasketDropdownVariant">
								<div className="shoppingBasketPreBasketDropdownVariantName">{product.variantName1.value}</div>
								<Dropdown
									className="shoppingBasketPreBasketDropdownVariantDropWrapper"
									menuClassName="shoppingBasketPreBasketDropdownMenu"
									placeholderClassName="shoppingBasketPreBasketDropdownPlaceholder"
									options={product.variantValues1.value}
									onChange={(e) => this.handleDropdownVariants1(e)}
									value={currentDropValue1}
									placeholder="Select an option"
								/>
							</div>

							<div className="shoppingBasketPreBasketDropdownVariant">
								<div className="shoppingBasketPreBasketDropdownVariantName">{product.variantName2.value}</div>
								<Dropdown
									className="shoppingBasketPreBasketDropdownVariantDropWrapper"
									menuClassName="shoppingBasketPreBasketDropdownMenu"
									placeholderClassName="shoppingBasketPreBasketDropdownPlaceholder"
									options={product.variantValues2.value}
									onChange={(e) => this.handleDropdownVariants2(e)}
									value={currentDropValue2}
									placeholder="Select an option"
								/>
							</div>
						</div>
					</div>

					<div
						className="shoppingBasketListSingleProductMiddleSectionViewButton"
						onClick={() => this.handlePrebasketAddToCart(product, this.state.currentDropdownValue1, this.state.currentDropdownValue2)}
					>
						{this.props.t('ADD_TO_CART')}
					</div>
				</>
			);
		}
	};

	renderProductCartList = (productArray) => {
		return (
			<div className="shoppingBasketCartProductListWrapper">
				{productArray.map((product) => {
					return this.renderCartProduct(product);
				})}
			</div>
		);
	};

	renderProductAllList = (productArray) => {
		return (
			<div className="shoppingBasketCartAllProductListWrapper">
				{productArray.map((product) => {
					return this.renderListProduct(product);
				})}
			</div>
		);
	};

	render() {
		const { currentMediaId, settings, mediasData, showShoppingCart, t, cartArray, listArray, isMobile } = this.props;
		const currentMedia = mediasData.find((media) => media?.id === currentMediaId);

		if (currentMedia?.custom?.['event-start']) {
			return null;
		}

		const color = settings?.playerStyling?.primaryColor ?? '#126cfc';
		const primaryColor = { color: color };
		const primaryBGColor = { backgroundColor: tinycolor({ ...tinycolor(color).toRgb(), a: 0.2 }).toRgbString() };

		return (
			settings.engagementFeatures.enabled && settings.engagementFeatures.showShoppingCart && (
				<div
					className={joinClassNames([
						'shoppingBasketContainer',
						isMobile ? 'shoppingBasketContainer--mobile' : '',
						showShoppingCart ? 'shoppingBasketContainer--visible' : '',
					])}
				>
					<div className="shoppingBasketTabWrapper">
						<div className="shoppingBasketBackButton" onClick={() => this.handleButtonCloseCart(showShoppingCart)}>
							<svg xmlns="http://www.w3.org/2000/svg" width="7.002" height="13.002" viewBox="0 0 7.002 13.002">
								<path
									id="chevron-down"
									d="M.147.147a.5.5,0,0,1,.708,0L6.5,5.794,12.147.147a.5.5,0,1,1,.708.708l-6,6a.5.5,0,0,1-.708,0l-6-6a.5.5,0,0,1,0-.708Z"
									transform="translate(0 13.002) rotate(-90)"
									fillRule="evenodd"
								/>
							</svg>
						</div>
						<div
							className={this.state.currentTab === 'cart' ? 'shoppingBasketCartButton highlightedTab' : 'shoppingBasketCartButton'}
							onClick={this.handleCartButtonClick}
						>
							{t('CART')}
						</div>

						<div
							style={{
								width: '0px',
								height: '20px',
								display: 'inline-block',
								border: '1px solid #E5E9EC',
								position: 'absolute',
								left: '50%',
							}}
						></div>

						<div
							className={
								this.state.currentTab === 'list'
									? 'shoppingBasketShoppingListButton highlightedTab'
									: 'shoppingBasketShoppingListButton'
							}
							onClick={this.handleShoppingListButtonClick}
						>
							{t('PRODUCT_LIST')}
						</div>
					</div>
					{this.state.currentTab === 'cart' ? (
						<div className="shoppingBasketCartWrapper">
							<div className="shoppingBasketCartProductList">{this.renderProductCartList(cartArray)}</div>
							<div className="shoppingBasketCartTotalPrice">
								<div className="shoppingBasketCartTotalText">{t('TOTAL')}</div>
								{this.getTotalPrice(cartArray)}
							</div>
							<div
								className="shoppingBasketCartCheckoutButton"
								style={{ ...primaryColor, ...primaryBGColor }}
								onClick={() => this.handleCheckoutButton(cartArray)}
							>
								{t('GO_TO_CHECKOUT')}
							</div>
						</div>
					) : this.state.currentTab === 'list' ? (
						<div className="shoppingBasketCartWrapper">
							<div className="shoppingBasketCartAllProductList">{this.renderProductAllList(listArray)}</div>
						</div>
					) : (
						<div className="shoppingBasketPrebasket">{this.renderPrebasket(this.state.prebasketProduct)}</div>
					)}
				</div>
			)
		);
	}
}

const mapStateToProps = ({ playerReducer, shoppingReducer, configurationReducer }) => ({
	showShoppingCart: playerReducer.showShoppingCart,
	cartArray: shoppingReducer.cartArray,
	listArray: shoppingReducer.listArray,
	currentPrebasketProduct: shoppingReducer.currentPrebasketProduct,
	prebasketUpdated: shoppingReducer.prebasketUpdated,
	cartQuantity: shoppingReducer.cartQuantity,
	mediasData: configurationReducer.mediasData,
	currentMediaId: configurationReducer.currentMediaId,
});

const mapDispatchToProps = (dispatch) => ({
	setCartArray: (value) => dispatch(setCartArray(value)),
	setShowShoppingCart: (value) => dispatch(setShowShoppingCart(value)),
	setCurrentPrebasketProduct: (value) => dispatch(setCurrentPrebasketProduct(value)),
	setPrebasketUpdated: (value) => dispatch(setPrebasketUpdated(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(ShoppingBasket);
